import { controls, currencyToNumber, grouped } from "../../controls";

const todays_branch_suggestions = {
  label: "Todays Branch Suggestions",
  starting: true,
  url: "todays_branch_suggestions",
  pageLabel: "Todays Branch Suggestions",
  pageType: "history",
  visitingBranches: true,
  filter: [
  ],
  form: [],
  history: {
    perPage: 50,
    reportHeader: "Todays Branch Suggestions",
    filterable: true,
    sortable: true,
    defaultsTo: 0,
    pdfProps: { pageSize: "A4", pageOrientation: "portrait" },
    extraRows: {
      location: "top",
      fields: ["total_amount"],
      grandtotal: { type: "fixed", displayIn: "full_name", val: "Grand Total", count: true },
    },

    displayColumns: [
      {
        Header: "Sr", type: "autoinc", accessor: "srno", align: "center", width: 30,
        width132: { size: 3 }
      },
      {
        Header: "Name",
        accessor: "full_name",
        rwidth: "*"
      },
      {
        Header: "Talathi Account Number",
        accessor: "talathi_account_no"
      },
      {
        Header: "Suggested Account Number",
        accessor: "suggested_account_number"
      },
      {
        Header: "Total Amount",
        accessor: "total_amount"
      },
      {
        Header: "Village",
        accessor: "village_display"
      },
      {
        Header: "Branch",
        accessor: "branch_display"
      },
    ]
  }
};

export default todays_branch_suggestions;